module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('article', {
    staticClass: "article"
  }, [_c('p', {
    staticClass: "tc fwbd mt20"
  }, [_vm._v("上海华瑞银行电子账户服务协议")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin  mt20"
  }, [_vm._v("甲方:客户")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin"
  }, [_vm._v("乙方:上海华瑞银行股份有限公司 甲方系自愿申请使用乙方电子账户、资金代收付业务及配套软硬件系统、网络、数据库的自 然人。乙方系乙方提供相关金融产品与服务的民营银行。为明确双方的权利和义务,维护 双方的合法权益,特签订本服务协议。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第一条 声明与承诺")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 甲方在确认本协议之前,应仔细阅读协议的全部内容。如果甲方对本协议的任何条款有 异议,请不要确认,并立即停止后续操作。甲方一旦接受本协议,即表示甲方充分理解并接 受本协议全部内容,并与乙方就电子账户及资金收付服务的相关事宜达成一致意见。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 甲方承诺自己是已满 18 周岁且具有完全民事行为能力和民事权利能力的自然人,具备签 署与履行本协议的基本条件和资格。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3. 乙方根据国家相关法律、法规、政策等规范性文件向甲方收取服务费用,具体内容及收 费标准以乙方对外公告为准。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第二条 定义与释义")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 电子账户:指甲方本人通过互联网、移动互联网、远程柜员终端、网点柜面等乙方或者 与乙方合作的第三方渠道自助申请,经乙方核准后为甲方开立的,仅供甲方通过乙方的或者 与乙方合作的第三方渠道办理金融业务的个人人民币银行II类账户。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 客户身份信息:指根据国家法律法规和乙方的相关管理制度,甲方向乙方申请开立电子账户时必须向乙方提供的、可证明自身身份的信息,包括不限于姓名、性别、国籍、职业、 住所地或常住地址、联系方式、证件类型和证件号码、证件原件及影印件或复印件、验证卡 卡号或存折、证件有效期等。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3. 乙方合作的第三方:系指与乙方建立关于电子账户合作关系的法人或其他组织。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("4. 绑定手机号码:指甲方在申请开立电子账户时,指定的关联电子账户的手机号码。绑定 的手机号码用于接收乙方发送的授权码、短信验证码以及交易提示短信等。乙方认为必要时, 可通过此手机号码向甲方核实身份信息和交易信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("5. 密码:指乙方或乙方合作的第三方用以识别甲方身份与指令要求甲方提供的代码或口令。 包括但不限于登录密码、交易密码、动态密码等多个种类,具体业务中使用的密码类别以乙 方要求为准。动态密码包括但不限于短信验证码,短信验证码指在甲方使用电子账户过程中, 乙方通过指定客服号码以手机短信息方式发送到绑定手机号码的特定代码。乙方有权基于特 殊的业务场景并取得甲方同意的情况下,为乙方提供小额免密服务。 特别地,当电子账户用于特定的场景、功能、目的时,与乙方合作的第三方在经乙方同意的 基础上,可为电子账户建立独立的交易密码验证体系,用户的交易密码由用户在第三方渠道 自行设置。在甲方交易过程中,乙方合作的第三方有权进行密码核验。此种情况下,乙方可 不再对甲方身份进行识别,而是默认接受合作方对客户身份的识别与指令的校验的结果。 ")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("6. 资金代收:是指甲方向乙方申请开立电子账户后,下达指令通过乙方资金结算系统或与 第三方支付公司合作的资金收付系统,将甲方本人在他行开立的人民币结算账户中的资金, 代扣至本行账户中的业务。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("7. 资金代付:是指甲方向乙方申请开立电子账户后,下达指令通过乙方资金结算系统或与 第三方支付公司合作的的资金收付系统,将甲方在该电子账户中的资金,代付至其指定的银 行算账户中的业务。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第三条 申请与开户")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 甲方自愿申请开立电子账户,并承诺申请电子账户时具有完全民事行为能力。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 电子账户申请渠道及身份识别: ")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(1)乙方自营渠道:甲方可通过乙方直销银行渠道、远程柜员终端(VTM)渠道和乙方不时指 定的其他渠道,提交电子账户开立申请及开户必须的相关身份信息,乙方根据甲方提供的身 份信息识别甲方身份。 ")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(2)乙方合作渠道:甲方可通过与乙方合作的第三方渠道提交电子账户开立申请,乙方具有 以下义务:")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("A. 根据甲方直接提供的身份信息,自行识别甲方身份;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("B. 或委托该与乙方合作的第三方渠道识别甲方身份。甲方同意授权与乙方合作的第三方渠 道向乙方传递甲方身份信息,但乙方应留存甲方身份信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3. 乙方负责审核甲方电子账户开立条件,一旦符合条件时,乙方应为甲方开立电子账户。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第四条 凭证和签章")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 甲方知悉并同意,乙方电子银行系统存储的与服务相关的数据电文是甲方使用电子账户 情况的有效书面证明。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 甲方认可:")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(1) 甲方在乙方自营渠道申请开立电子账户,以及在乙方合作渠道申请开立电子账户、由乙 方自行识别甲方身份时,使用密码的行为,即视同中国法律法规及规章规定的甲方签章行为, 即构成甲方可靠的电子签名,均表明了甲方认可其中交易内容。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(2) 甲方在与乙方合作渠道申请开立电子账户、由乙方委托乙方合作的第三方渠道识别甲方身份时,通过第三方账户的身份验证的电子方式即构成甲方可靠的电子签名,甲方同意乙方不再校验在该电子账户下的甲方身份,且同意由该第三方传递给乙方的动用电子账户的指令 视为甲方下达。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3. 甲方若遗忘电子账户登录密码或交易密码,可通过乙方或乙方合作的第三方根据不同电 子账户申请渠道进行密码重置。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第五条 账户使用")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 乙方为甲方开立电子账户成功后,甲方即可按协议约定在乙方的自建平台或合作渠道上 使用电子账户。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 甲方知悉并同意: (1)甲方通过政府部门数据库、自身数据库、临柜或合作的第三方等乙方认可的方式完成身 份验证后,即可使用经乙方合作渠道开立的电子账户。 (2)甲方使用经乙方自营渠道开立的电子账户,乙方识别甲方身份的依据为密码,不同业务 使用的密码类别以乙方规定为准。 (3)乙方根据不同的验证方式和业务风险,对电子账户的功能进行不同程度的限制,具体内 容以乙方公布的范围和标准为准。 (4)通过乙方合作渠道开立的电子账户,账户使用限制以合作渠道发布的公告为准。 (5)在乙方认为账户注册和交易行为异常,有可能危及甲方资金安全的情况下,乙方可以 采取增强客户身份、确认账户交易的验证措施,包括但不限于短信验证码、交易密码、人脸 识别、人工电话或视频核实等。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3. 电子账户只限甲方本人使用,不得出借、转让或出租。否则,由此产生的损失由甲方自 行承担。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("4. 甲方在乙方开立、使用、注销电子账户,应遵守《人民币银行结算账户管理办法》等中华人民共和国的法律、法规和中国人民银行、中国银行业监督管理委员会及国家外汇管理局 的各项规定及乙方的业务制度规定。因操作不当造成的损失,乙方不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("5. 甲方承诺向乙方提供的所有资料真实、有效、完整、准确、合法,提交的开户证件符合 《个人存款账户实名制规定》,未由他人代办或冒充他人申请。如甲方提供的资料不符合要 求或存在代办、冒充他人申请等情形,乙方有权拒绝甲方的申请,对于已经开立了电子账户 的,乙方有权终止协议。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("6. 甲方应妥善保管电子账户的密码、个人有效身份证件、绑定的手机等个人信息和设备, 如上述信息或设备出现遗失、泄露或出现被他人盗用的情况,引发的后果与责任概由甲方自 行承担。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("7. 甲方须及时关注电子账户资金变化情况,发现可疑的资金变动或其他可疑情况时,应立 即通过乙方认可的渠道主动办理账户挂失手续,通过互联网或电话挂失为临时挂失,挂失手 续办妥,挂失立刻生效,临时挂失有效期为 15 个自然日,有效期满挂失自动失效。甲方需 在有效期届满前到乙方营业网点办理正式挂失手续。对挂失生效前或挂失失效后甲方因遗失 账户介质产生的经济损失,乙方不承担责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("8. 甲方知悉并同意,由于技术原因,乙方无法确保系统不间断无差错运行,但乙方出于电 子账户维护升级的需要而停止电子账户的部分或全部时,应及时通过网站进行公告,由于乙 方无法控制的原因发生的电子账户系统停运,乙方将在发生停止运营后及时通过网站进行公 告。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("9. 甲方应当准确提供并及时更新所提供的电子邮件地址、联系电话、联系地址、邮政编码 等联系方式,以便乙方进行及时、有效联系。甲方应完全独自承担因通过这些联系方式无法 与其取得联系而导致的甲方在使用本服务过程中遭受的任何损失或增加任何费用等不利后\n        果。甲方理解并同意,甲方有义务保持其提供的联系方式的有效性,如有变更需要更新的,甲方应按乙方的要求进行操作。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("10. 甲方不能将电子账户用于任何非法场所,包括购买当地法律禁止的商品和服务,甲方自 行承担在非法场所使用导致的风险。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("11. 甲方可通过向乙方合作的第三方渠道提交电子账户动账明细查询申请:甲方同意授权乙 方向其合作的第三方渠道传递甲方在该渠道的动账明细,信息仅供甲方自查。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("12. 电子账户不设有效期,在注销前均可使用。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("13. 电子账户的注销")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(1) 甲方可申请注销电子账户,电子账户下无有效签约产品时,乙方为甲方办理注销电子账 户。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(2) 乙方发现甲方身份信息不真实,或有理由认为其操作行为已经影响系统稳定运行、影响 其他用户正常使用、从事违法活动或产生其他严重后果时,有权注销甲方的电子账户。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(3) 其他法定的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("14. 甲方知悉并同意遵守经乙方合作渠道开立的电子账户的下述特殊使用规则")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(1) 该类账户的信息包括但不限于购买产品信息、账户信息。由乙方传输至乙方合作的第三 方的,甲方可通过第三方渠道查询账户信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(2)甲方在乙方的自建渠道完成登录或者特殊情下向乙方提供有效的身份证明、账户证明后, 可在乙方查询、修改账户信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("15.甲方利用电子银行互联网平台进行电子支付、外汇、国债、基金、理财等交易,应同意 与乙方通过电子渠道签署电子银行互联网平台投资服务协议等相关协议。甲方应充分认识到 投资类业务的风险,并对其电子银行互联网平台投资类交易活动产生的结果承担全部责任。 ")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("16.甲方知悉并同意,乙方有权按照国家法律法律要求,对账户使用进行额度限制,包括但不限于单笔额度限制、日累计额度限制、单日笔数限制和年累计额度限制。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin"
  }, [_vm._v("17.甲方知悉并同意,乙方通过甲方留存的联系电话发送各类通知短信,以实际交易为准, 乙方有权解释短信内容。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin"
  }, [_vm._v("18. 特别须知。为保障客户的账户安全,华瑞银行有可能针对长期不动账户实行销户操作管 理。条件设定:")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin"
  }, [_vm._v("1. 甲方在乙方开立的所有账户连续 24 个月以上没有收支记录(不包括如计息、账户管理 费扣除等系统交易);")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin"
  }, [_vm._v("2. 甲方所有账户余额均为零;")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin"
  }, [_vm._v("3. 持有长期定存、理财产品、贷款等非活期存款产品的除外; 账户被注销后,甲方将无法继续办理与该等被注销账户有关的交易或业务,乙方亦不再继续 就该等被注销账户向甲方提供任何服务(包括但不限于借记卡服务、电话银行服务、短信银 行服务、电子月结单服务、电子通知书服务、海外汇款服务等,任何基于或与被注销账户直 接或间接相关的业务/服务)。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第六条 账户指令与记录")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 电子账户的数据电文(包括但不限于甲方通过电子渠道传递的指令、电子账户交易信息 等),甲方知悉并同意,均以乙方系统记录的资料为准,双方均承认乙方电脑记录资料的真 实性、准确性和合法性。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 电子账户不寄送纸质对账单,甲方可通过乙方或乙方合作的第三方渠道核对交易记录。 如甲方对交易有异议,可致电乙方客户服务电话 400-767-5588 。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3. 如乙方发现有下列情形之一,乙方有权不认可或不执行数据电文表达的甲方指令")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(1) 乙方有充足的理由怀疑数据信息或甲方指令的真实性;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(2) 乙方执行甲方指令将违反相关的法律、法规或规章的规定;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(3) 甲方发出的数据电文表达的格式、内容、操作权限等不符合乙方要求;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(4) 电子账户中的余额或账户状态不足以完成甲方指令(上述情况下乙方有权根据具体情况 决定对数据电文表达的甲方指令不予执行或给予部分执行);")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(5) 甲方账户内资金被依法冻结或扣划;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(6) 甲方违反本协议或双方已订立的其他协议或合同的;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(7) 不可抗力或其他不可归因于乙方的情况;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(8) 双方特别约定或法律法规规定的其他情况。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("4. 甲方有权按照乙方的电子账户业务规则向乙方发出划转电子账户资金的指令,乙方应实 时执行所接收到的甲方指令。甲方同意,乙方收到指令并将指令提交至乙方资金结算系统或 与第三方合作渠道的资金收付系统即为甲方指令执行完成。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("5. 乙方依据甲方的要求向甲方他行关联账户发起资金代收和代付交易时,指令一经发出, 即为不可撤销。甲方的其他账户指令一经发出,除乙方允许情况外,不得要求撤销。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第七条 资金代收付授权")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 甲方知悉并同意:乙方可根据业务需要,要求甲方在开立和使用电子账户时,指定一张 或多张本人所有的人民币银行账户与电子账户进行绑定。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 甲方承诺资金收付指定的关联账户号为本人所有,并保证对其本人绑定账户信息的真实 性、合法性、有效性及准确性负责。如因填写内容有误导致资金收付失败或出错,由此造成 的一切后果由甲方自行承担,乙方不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3. 甲方授权乙方在甲方发起资金收付指令或约定定期交易的指定时间,由乙方通过自建或 合作通道,或者由乙方合作的第三方通过第三方支付通道,完成甲方绑定账户与电子账户之间的资金划拨,但依特定的交易场景、业务规则或法律法规约束,在具体应用中不支持上述资金划拨的除外。资金收付指令包括但不限于投资理财、充值提现、消费等场景的交易请求。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("4 甲方授权乙方可通过乙方自建的资金归集通道,或与乙方有资金收付合作关系的中国人民 银行、中国银联及其分支机构,以及其他商业第三方支付机构所搭建的资金收付通道,对本 人所有的绑定账户进行资金的扣划和支付。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("5. 甲方知悉并同意:乙方根据不同的资金收付通道和业务场景需要,对电子账户的资金流 向采取不同的控制手段。电子账户默认与绑定账户之间进行资金的划入和划出。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("6. 甲方在此承诺并保证,甲方授权乙方从本人绑定账户扣划并归集至电子账户的资金来源 及用途合法。如甲方出现涉嫌洗钱等违法活动,乙方有权单方面采取交易限制措施,包括但 不限于要求甲方协助调查、关闭享受服务的产品和渠道、暂停向其提供资金收付等业务服务, 由此产生的一切后果由甲方自行承担。若乙方根据业务需要或因配合有关主管部门工作需要 而要求甲方协助调查的,甲方应按照乙方要求,在三个工作日内提供资金来源、用途等交易 背景资料及因业务、配合有关主管部门工作需要而不时要求的其他资料。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("7. 乙方仅根据本协议对甲方绑定账户进行资金收付业务时,因甲方绑定账户信息验证不成 功、账户状态异常、账户余额不足等因素,或由于不能预见、不可克服、不可避免的不可抗 力因素或其他无法控制的客观因素等非乙方原因导致的无法及时扣款或扣款出错、失败的, 乙方不再重复发起资金收付交易,且对此不承担任何责任,相应后果由甲方承担。如因甲方 原因导致交易出错或失败,并因此致使乙方垫付资金的,乙方有权向甲方追索垫付资金,并 有权对甲方在乙方开立的任一账户内的存款进行扣划。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("8. 甲方因乙方系统差错、故障、错账或其他原因获得不当得利时,同意乙方从其账户中扣 划相关不当得利所涉及的资金、产品份额或暂停其相关网络金融渠道服务。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第八条 信息披露与保密")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 乙方在本协议履行过程中知悉的甲方的资料及信息,乙方应负保密责任,但下列情形除外")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(1) 适用法律法规或上市规则要求披露的;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(2) 司法部门或政府部门要求披露的;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(3)向乙方的外部专业顾问披露的;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(4) 甲方同意或授权乙方进行披露的。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 甲方同意乙方在如下情形可以使用或披露所有有关甲方的信息和资料,包括但不限于甲 方的个人基本信息、主卡、验证卡及电子账户及交易信息及其他相关信息和资料等,愿意承 担由此产生的一切后果:")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(1) 依照法律、法规和规范性法律文件规定,必须向监管机关或其他有权机关披露。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(2) 为下列目的向业务外包机构、与乙方合作的第三方、其他金融机构及乙方认为必要的其 他机构或个人,包括但不限于乙方的其他分支机构,或者乙方完全或部分拥有的子公司,披 露和允许其使用该等信息和资料:")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("A. 为开展网络金融业务服务或与网络金融业务服务有关;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("B. 为向甲方提供或可能提供新产品或服务或进一步提供服务;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("C. 为更好地维护、管理和提升甲方关系。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(3) 为业务运营、管理、统计、分析和风险控制的目的使用或允许乙方合作的第三方在保密 的基础上使用该等信息和资料。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第九条 公告与变更")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 甲方同意,乙方可根据法律法规、业务需要,对本协议及电子账户使用规则进行补充通知和单方变更,通知和变更内容以乙方官方网站的公告为准。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 公告自发布之日起视为送达,公告发布之日起 7 个工作日内为公告期,如公告期满甲方 未提出解除本协议或暂停、终止使用电子账户服务的,视为甲方同意公告内容。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3. 乙方发布的公告内容对本协议项下的甲乙双方权利义务关系产生实质性影响的,若不涉 及本协议的修改,则公告内容视为对本协议的补充条款,自公告发布之日起第 8 个工作日 自动生效,甲乙双方不用另行签订其他协议。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("4. 乙方发布的公告内容对本协议项下的甲乙双方权利义务关系产生实质性影响的,若涉及 到对本协议项下条款的修改,则自公告发布之日起第 8 个工作日本协议自动修改并生效, 甲乙双方不用另行签订其他协议。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第十条 法律责任")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 乙方因过错未及时处理甲方提交的合法交易指令,应赔偿甲方的损失,但不包括对指令 执行后可以获得的利益的赔偿。乙方的损失赔偿责任在任何情况下均不超过支付指令的金额 或甲方直接损失的金额(以较少者为准)。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 若甲方违反本协议约定内容或存在恶意诋毁、侵害乙方声誉的行为,乙方有权单方面中 止或终止本协议。因甲方违约行为给乙方带来损失的,乙方保留向甲方追偿的权利。乙方终 止协议并不意昧着对协议终止前甲方所发出的未完成交易指令的撤销,不能免除终止协议前 甲方未尽的法律义务,也不能免除终止协议前甲方的交易所带来的任何法律后果。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第十一条 银行责任的免除与限制")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 乙方通过指定的自营渠道或合作渠道为甲方提供电子账户的业务服务,通过指定的服务 号码向甲方提供电子账户及相应业务的短信服务,因甲方相信欺诈电话、短信或虚假网站而\n        将电子账户信息泄露造成的全部损失由甲方自行承担。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 甲方使用电子账户时,如非乙方过错而发生的数据电文错误或者对甲方指令识别、处理 或执行错误时,乙方对因该项错误的发生所导致的损失和其他不利后果不承担责任,但乙方 可在甲方处理时对甲方提供必要的协助。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3. 若发生乙方对于合法有效的甲方指令识别错误或执行错误,则甲方须在知道或应当知道 错误发生后于三个工作日内书面通知乙方并尽力采取措施防止损失扩大,乙方应尽快调查处 理并在合理可行的范围内采取补救措施,对于因银行/电子账户系统错误而造成的甲方直接 财产损失,乙方应按适用的规则予以赔偿,但对于任何间接损失、履行利益、后果性损害、 非财产损害、乙方于错误发生时不可预见的损失以及因甲方未能及时通知或及时采取措施而 导致扩大的损失,乙方不承担责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("4. 对于不可抗力(包括但不限于战争、自然灾害、电力供应中断、火灾、地震等)、意外事 件或乙方无法控制的其他情况所造成的损失,乙方不承担责任。 5、乙方有权按照国家法律法规提供服务,如执行国家新颁布的法律法规而造成服务内容与 本协议约定不符的,乙方不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("第十二条 其他")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1. 本协议自甲方同意确认时正式生效;自甲方根据本协议约定办妥电子账户销户手续或乙方提出终止协议时终止。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2. 执行本协议发生争议,由当事人双方协商解决。协商不成,双方同意向乙方所在地人民法院起诉。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }), _vm._v(" "), _c('p', {
    staticClass: "txdr fwbd txin"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed0c78ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/persh.vue
// module id = 217
// module chunks = 0